import { render } from "./XIconSolidArrowsRightLeft.vue?vue&type=template&id=0e60b649"
import script from "./XIconSolidArrowsRightLeft.vue?vue&type=script&lang=js"
export * from "./XIconSolidArrowsRightLeft.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidArrowsRightLeft.vue"]])

export default __exports__